import { ArrowUpRight } from "lucide-react";

/** The link to design an area's pages in the Website. The area's sections are in the side menu, not repeated here. */
export function AreaHead({ designLabel, onDesign }: { designLabel: string; onDesign: () => void }) {
  return <div className="bw-area-head">
    <button type="button" className="bw-area-design" onClick={onDesign}>{designLabel} <span>· In Website</span><ArrowUpRight size={14} aria-hidden="true" /></button>
  </div>;
}
